import * as actionTypes from './types/managers';
import { get } from '@/utillity/createAction';

export const getManagersList = (params, id) => get(actionTypes.GET_MANAGERS.INIT, params, id);

export default getManagersList;
